import {LitElement, html, css} from 'lit-element';


class NavTagBucket extends LitElement {
    static get properties () {
        return {
            tagList: {
                attribute: 'tag-list',
                type: Array
            }
        };
    }


    static get styles () {
        return [
            css`
                :host {
                    display: block;
                }

                ul {
                    height: inherit;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }

                ul li {
                    display: inline-block;
                    height: inherit;
                }

                a {
                    text-decoration: none;
                }

                .nav-item {
                    color: #444;
                    font-family: 'Unify Sans', Helvetica, Arial, sans-serif;
                    font-size: calc(12px + (14 - 12) * ((100vw - 320px) / (1200 - 320)));
                    font-style: normal;
                    line-height: var(--line-height-default, 1.15);
                    margin: 0;
                    display: flex;
                    -ms-flex: 0 1 auto;
                    flex: 0 1 auto;
                    flex-direction: row;
                    flex-wrap: wrap;
                    -webkit-align-items: center;
                    align-items: center;
                    font-weight: var(--tag-bucket-font-weight, 600);
                    height: inherit;
                    padding: 0 12px;
                }

                .nav-item:hover,
                .nav-item:focus {
                    color: var(--tag-bucket-hover-color, #444);
                }

                .nav-item.active {
                    font-weight: var(--tag-bucket-active-font-weight, 900);
                }

                
                @media all and (min-width: 1200px) {
                    .nav-item {
                        font-size: 14px;
                    }
                }
            `
        ];
    }

    constructor () {
        super();

        this.tagList = [];
    }


    render () {
        return html`
        <ul id="itemWrapper">
            ${
                this.tagList.map(navItem => {
                    return html`
                        <li>
                            <a href="${navItem.url}" class="nav-item ${navItem.key}">${navItem.name}</a>
                        </li>
                    `;
                })
            }

        </ul>
        `;
    }
}

customElements.define('nav-tag-bucket', NavTagBucket);